import * as fromMembers from './member/member.reducer';
import * as fromCryptoKey from './crypto-key/crypto-key.reducer';

export const FEATURE_KEY = 'team-chat';

export interface TeamChatState {
  [fromMembers.FEATURE_KEY]: fromMembers.State;
  [fromCryptoKey.FEATURE_KEY]: fromCryptoKey.State;
}
